const Barba = require('Barba');
import * as animations from "../animations";

export const DefaultReplaceTransition = Barba.BaseTransition.extend({
  start: function () {
    Promise
      .all([this.newContainerLoading, this.out()])
      .then(this.in.bind(this));
  },

  out: function () {
    let $oldContainer = $(this.oldContainer);
    let promise = $.Deferred();

    if ($oldContainer.data('animation-out')) {
      let animationName = $oldContainer.data('animation-out');
      let animationClass = new animations[animationName]();

      let tl = animationClass.out($oldContainer);

      promise.then(function () {
        //console.log(tl);
        tl.play();
      });

      return promise.resolve();

    } else {
      // Remove homepage class from body if body has it
      const $body = $('body');
      if ($body.hasClass('homepage')) {
        $body.removeClass('homepage');
      }
      return $(this.oldContainer).animate({opacity: 0}, 300).promise();
    }

  },

  in: function () {

    window.pew.enhanceRegistry();
    let $newContainer = $(this.newContainer);

    $newContainer.css({
      visibility: 'visible'
    });

    document.body.scrollTop = 0;
    $('html').scrollTop(0);

    if ($(this.oldContainer)) {
      $(this.oldContainer).hide();
    }

    if ($newContainer.data('animation-in')) {
      let animationName = $newContainer.data('animation-in');
      let animationClass = new animations[animationName]();
      let tl = animationClass.in($newContainer, {
        onComplete: this.done.bind(this)
      });
      tl.play();

    } else {
      let $el = $(this.newContainer);
      $(this.oldContainer).hide();

      $el.css({
        visibility: 'visible',
        opacity: 0
      });
      $el.animate({opacity: 1}, 400, () => {
        /**
         * Do not forget to call .done() as soon your transition is finished!
         * .done() will automatically remove from the DOM the old Container
         */

        this.done();
      });
    }

  }

});
